export default [
    {
        path: "/danger",
        name: "danger",
        component: () => import("./tab/List.vue"),
        meta: {
            // permiss:['SAFETY_DANGER_SHOW'],
            title: "隐患排查"
        }
    },
    {
        path: "/danger/:source/update",
        name: "danger",
        component: () => import("./Update.vue"),
        meta: {
            // permiss:['SAFETY_DANGER_SHOW'],
            title: "新增隐患"
        }
    },
    {
        path: "/danger/:source/update/:prospectTaskId",
        name: "danger",
        component: () => import("./Update.vue"),
        meta: {
            // permiss:['SAFETY_DANGER_SHOW'],
            title: "新增隐患"
        }
    },
    {
        path: "/danger/update/:id",
        name: "danger",
        component: () => import("./Update.vue"),
        meta: {
            // permiss:['SAFETY_DANGER_SHOW'],
            title: "修改隐患"
        }
    },
    {
        path: "/danger/submit/:id",
        name: "dangerDeal",
        component: () => import("./Submit"),
        meta: {
            // permiss:['SAFETY_DANGER_SUBMIT'],
            title: "提交隐患"
        }
    },]